import { cn } from '@/lib/utils';
import type { MemberPortalMembership } from '@/services/publicClubMembership';
import { MembershipPaymentHistory } from '@/components/membership/MembershipPaymentHistory';
import {
  MembershipHouseholdSection,
  MembershipMemberSinceCard,
} from '@/components/membership/membershipPortalShared';

interface MembershipPortalAsideProps {
  clubSlug: string;
  memberships: MemberPortalMembership[];
  className?: string;
}

export function MembershipPortalAside({
  clubSlug,
  memberships,
  className,
}: MembershipPortalAsideProps) {
  return (
    <aside className={cn('space-y-6 lg:sticky lg:top-8', className)}>
      <MembershipMemberSinceCard memberships={memberships} />
      <MembershipHouseholdSection memberships={memberships} />
      <MembershipPaymentHistory clubSlug={clubSlug} memberships={memberships} />
    </aside>
  );
}
